import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon71: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M10 0c2.499 0 4.5 2.027 4.5 4.576 0 .138-.009.279-.026.423l2.22.001c.96 0 1.783.71 2.007 1.701l1.287 5.689a.5.5 0 0 1-.488.61l-1.5-.001v5.5c0 .82-.625 1.501-1.42 1.501H3.42C2.626 20 2 19.319 2 18.499v-5.5L.5 13a.5.5 0 0 1-.487-.61l1.286-5.689C1.523 5.71 2.346 5 3.307 5h2.22a3.487 3.487 0 0 1-.027-.424C5.5 2.027 7.502 0 10 0Zm1 12.999H3v5.5c0 .286.198.501.42.501H11v-6.001Zm6 0h-5V19h4.58c.223 0 .42-.215.42-.501v-5.5ZM16.694 6l-2.46-.001c-.04.114-.083.229-.13.346-.273.672-.672 1.378-1.164 2.099a18.847 18.847 0 0 1-1.52 1.929 1.92 1.92 0 0 1-2.839 0 18.87 18.87 0 0 1-1.52-1.929c-.492-.721-.892-1.427-1.164-2.099a6.961 6.961 0 0 1-.13-.346L5.518 6H3.306c-.477 0-.907.371-1.031.921L1.125 12h17.75l-1.15-5.079c-.124-.55-.554-.921-1.03-.921ZM10 1C8.057 1 6.5 2.577 6.5 4.576c0 .4.11.869.323 1.393.243.598.608 1.244 1.064 1.911a17.64 17.64 0 0 0 1.426 1.812.919.919 0 0 0 1.374 0 17.578 17.578 0 0 0 1.427-1.812c.455-.667.82-1.313 1.063-1.911.213-.524.323-.993.323-1.393C13.5 2.577 11.944 1 10 1Zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
      />
    </Svg>
  )
}
